import { ContentType } from '../../services';
import { QueueConfiguration } from '../../services';

const AllowedModerators = [
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'cbeckford@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'anatkins@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'josasaki@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'lsanchez@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'michsco@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'khharper@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: false,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: false,
    userId: 'nhubbell@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: false,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: false,
    userId: '@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: false,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: false,
    userId: 'katls@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'davidcat@ntdev.microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: false,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: false,
    userId: 'ivoryh@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'v-erosales@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'kakhap@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'kyeg@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'miso@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'v-jleonovics@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'v-nijedu@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'davega@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'esaumena@microsoft.com',
    userType: 'Moderator'
  },
  {
    canSetGroundTruthCaseActions: true,
    canSetGroundTruthFeedback: true,
    canSetSourceWeight: true,
    userId: 'larryukaoma@microsoft.com',
    userType: 'Moderator'
  }
];
const AllowedAdmins = [
  {
    userId: 'cbeckford@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'anatkins@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'josasaki@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'lsanchez@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'michsco@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'khharper@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'davidcat@ntdev.microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'ivoryh@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'kakhap@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'kyeg@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'nhubbell@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'v-erosales@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'miso@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'v-jleonovics@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'v-nijedu@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'davega@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'esaumena@microsoft.com',
    userType: 'Admin'
  },
  {
    userId: 'larryukaoma@microsoft.com',
    userType: 'Admin'
  }
];

export const ModerationQueueConfigs: QueueConfiguration[] = [
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 1500,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.text,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 1
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '0',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Text',
    tenant: {
      displayName: 'MinecraftDev',
      tenantId: '488296E409C5C8B8',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'EarthDev',
      titleId: 'BC4A'
    },
    displayName: 'Text',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 1,
    categorizedTraits: {
      default: ['Other', 'Inappropriate', 'Unsafe', 'No action']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 1500,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.gpsdd,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '1',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'LocationUnsafe',
    tenant: {
      displayName: 'MinecraftDev',
      tenantId: '488296E409C5C8B8',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'EarthDev',
      titleId: 'BC4A'
    },
    displayName: 'Location Unsafe',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 1,
    categorizedTraits: {
      default: ['Other', 'Inappropriate', 'Unsafe', 'No action']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 3600,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.text,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '2',
    moderatorFeedbackCommentOptional: true,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Test',
    tenant: {
      displayName: 'CepEngineeringStudio',
      tenantId: 'AB983273D3127C54',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'CepTest',
      titleId: '28E28'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 20,
    categorizedTraits: {
      default: ['Other', 'Inappropriate', 'Unsafe', 'No action']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 1800,
    caseOpenLifetimeInSeconds: 86400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.gpsdd,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '3',
    moderatorFeedbackCommentOptional: false,
    revision: 2,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Location',
    tenant: {
      displayName: 'CepEngineeringStudio',
      tenantId: 'AB983273D3127C54',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'CepTest',
      titleId: '28E28'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeightRate',
    defaultMaxAssignedCaseCount: 4,
    categorizedTraits: {
      default: ['Other', 'Inappropriate', 'Unsafe', 'No action']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 3600,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.gpsdd,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '4',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Location',
    tenant: {
      displayName: 'CepEngineeringStudio',
      tenantId: 'AB983273D3127C54',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'CepTest',
      titleId: '28E28'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeightRate',
    defaultMaxAssignedCaseCount: 1,
    categorizedTraits: {
      default: ['Other', 'Inappropriate', 'Unsafe', 'No action']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 1800,
    caseOpenLifetimeInSeconds: 86400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.text,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        categoriesTop: ['dogs', 'plants'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '5',
    moderatorFeedbackCommentOptional: true,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Test',
    tenant: {
      displayName: 'CepEngineeringStudio',
      tenantId: 'AB983273D3127C54',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'CepTest',
      titleId: '28E28'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 20,
    categorizedTraits: {
      boring: ['Other', 'Inappropriate', 'Unsafe', 'No action'],
      plants: ['oak', 'ivy', 'rose', 'grass', 'tulip', 'blueberry'],
      dogs: ['Lab', 'Poodle', 'Retriever']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 1200,
    caseOpenLifetimeInSeconds: 86400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        categoriesTop: ['dogs', 'plants'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '6',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Streaming',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Moderation',
      titleId: 'Moderation'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 604800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 1,
    categorizedTraits: {
      boring: ['Other', 'Inappropriate', 'Unsafe', 'No action'],
      plants: ['oak', 'ivy', 'rose', 'grass', 'tulip', 'blueberry'],
      dogs: ['Lab', 'Poodle', 'Retriever']
    },
    sourceTypeWeightMappings: {
      Moderator: 1
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 600,
    caseOpenLifetimeInSeconds: 86400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        labelsTop: ['Threats'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: true
      }
    },
    id: '7',
    moderatorFeedbackCommentOptional: true,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Chat',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Moderation',
      titleId: 'Moderation'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 604800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 10,
    categorizedTraits: {
      default: [
        'Harassment',
        'Hate speech',
        'Inappropriate behavior with a minor',
        'Inappropriate content',
        'Self-harm',
        'Sexual content',
        'Threats',
        'Violent extremist content',
        'Non-violating'
      ]
    },
    sourceTypeWeightMappings: {
      Moderator: 1
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 600,
    caseOpenLifetimeInSeconds: 360,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: true
      }
    },
    id: '8',
    moderatorFeedbackCommentOptional: true,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'ChatTest',
    tenant: {
      displayName: 'Mixer',
      tenantId: 'Mixer',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Moderation',
      titleId: 'Moderation'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 604800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 6,
    categorizedTraits: {
      default: [
        'Harassment',
        'Hate speech',
        'Inappropriate behavior with a minor',
        'Inappropriate content',
        'Self-harm',
        'Sexual content',
        'Threats',
        'Violent extremist content',
        'Non-violating'
      ]
    },
    sourceTypeWeightMappings: {
      Moderator: 1
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 600,
    caseOpenLifetimeInSeconds: 360,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: true
      }
    },
    id: '9',
    moderatorFeedbackCommentOptional: true,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'ClubProfile',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 604800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 1,
    categorizedTraits: {
      default: [
        'Harassment',
        'Hate speech',
        'Inappropriate behavior with a minor',
        'Inappropriate content',
        'Self-harm',
        'Sexual content',
        'Threats',
        'Violent extremist content',
        'Non-violating'
      ]
    },
    sourceTypeWeightMappings: {
      Moderator: 1
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.image,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: true,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [
          {
            CSEAI:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          },
          {
            Terrorism:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          }
        ],
        labelsTop: ['Non-violating', 'Defer'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: true
      },
      subjectImage: {
        blurStrengthPixels: 10,
        isDefaultBlur: true,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '10',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'GamerPic',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 10,
    categorizedTraits: {
      '(non-IRL) CSEAI': ['Digitally-created CSEAI', 'Doctored imagery'],
      Abuse: ['Domestic abuse', 'Animal cruelty'],
      Cheating: ['Offering/Providing/Promoting mods'],
      'Commerce & advertising': ['Advertising'],
      Harassment: [
        'Trolling',
        'Threats',
        'Targeted harassment',
        'Sexual harassment',
        'Retaliation',
        'IRL or non-digital harassment',
        'Hate speech'
      ],
      Impersonation: ['Unauthorized use of identity'],
      'Personal information': ['PII'],
      Phishing: ['Promoting phishing'],
      Piracy: ['Copyright infringement'],
      'Pre-release play': ['Unauthorized content distribution & methods'],
      'Sensitive content': [
        'Weapons/Safety',
        'Vulgar',
        'Violent extremist content',
        'Self-harm',
        'Violence/Gore',
        'Drugs & alcohol abuse',
        'Controversial'
      ],
      Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
      'Unclear self-identification': ['Self-identification'],
      Terrorism: ['Terrorism'],
      CSEAI: ['CSEAI'],
      'Non-violating': ['Non-violating'],
      Defer: ['Defer']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      maxCardHeight: 156,
      disableFiltersOnSelect: true,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [
          {
            CSEAI:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          },
          {
            Terrorism:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          }
        ],
        labelsTop: ['Non-violating', 'Defer'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: true
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: true
      }
    },
    id: '11',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Identity',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 12,
    categorizedTraits: {
      '(non-IRL) CSEAI': ['Digitally-created CSEAI', 'Doctored imagery'],
      Abuse: ['Domestic abuse', 'Animal cruelty'],
      Cheating: ['Offering/Providing/Promoting mods'],
      'Commerce & advertising': ['Advertising'],
      Harassment: [
        'Trolling',
        'Threats',
        'Targeted harassment',
        'Sexual harassment',
        'Retaliation',
        'IRL or non-digital harassment',
        'Hate speech'
      ],
      Impersonation: ['Unauthorized use of identity'],
      'Personal information': ['PII'],
      Phishing: ['Promoting phishing'],
      Piracy: ['Copyright infringement'],
      'Pre-release play': ['Unauthorized content distribution & methods'],
      'Sensitive content': [
        'Weapons/Safety',
        'Vulgar',
        'Violent extremist content',
        'Self-harm',
        'Violence/Gore',
        'Drugs & alcohol abuse',
        'Controversial'
      ],
      Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
      'Unclear self-identification': ['Self-identification'],
      Terrorism: ['Terrorism'],
      CSEAI: ['CSEAI'],
      'Non-violating': ['Non-violating'],
      Defer: ['Defer']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.json,
    uxPreferences: {
      disableFiltersOnSelect: true,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [
          {
            CSEAI:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          },
          {
            Terrorism:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          }
        ],
        labelsTop: ['Non-violating', 'Defer'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: true
      },
      subjectImage: {
        blurStrengthPixels: 10,
        isDefaultBlur: false,
        isDefaultFlipped: true,
        isDefaultGrayscale: true,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '12',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'ImageJsonTest',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 12,
    categorizedTraits: {
      '(non-IRL) CSEAI': ['Digitally-created CSEAI', 'Doctored imagery'],
      Abuse: ['Domestic abuse', 'Animal cruelty'],
      Cheating: ['Offering/Providing/Promoting mods'],
      'Commerce & advertising': ['Advertising'],
      Harassment: [
        'Trolling',
        'Threats',
        'Targeted harassment',
        'Sexual harassment',
        'Retaliation',
        'IRL or non-digital harassment',
        'Hate speech'
      ],
      Impersonation: ['Unauthorized use of identity'],
      'Personal information': ['PII'],
      Phishing: ['Promoting phishing'],
      Piracy: ['Copyright infringement'],
      'Pre-release play': ['Unauthorized content distribution & methods'],
      'Sensitive content': [
        'Weapons/Safety',
        'Vulgar',
        'Violent extremist content',
        'Self-harm',
        'Violence/Gore',
        'Drugs & alcohol abuse',
        'Controversial'
      ],
      Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
      'Unclear self-identification': ['Self-identification'],
      Terrorism: ['Terrorism'],
      CSEAI: ['CSEAI'],
      'Non-violating': ['Non-violating'],
      Defer: ['Defer']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.video,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [
          {
            CSEAI:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          },
          {
            Terrorism:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          }
        ],
        labelsTop: ['Non-violating', 'Defer'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 10,
        isDefaultBlur: false,
        isDefaultFlipped: true,
        isDefaultGrayscale: true,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '13',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Video',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 12,
    categorizedTraits: {
      '(non-IRL) CSEAI': ['Digitally-created CSEAI', 'Doctored imagery'],
      Abuse: ['Domestic abuse', 'Animal cruelty'],
      Cheating: ['Offering/Providing/Promoting mods'],
      'Commerce & advertising': ['Advertising'],
      Harassment: [
        'Trolling',
        'Threats',
        'Targeted harassment',
        'Sexual harassment',
        'Retaliation',
        'IRL or non-digital harassment',
        'Hate speech'
      ],
      Impersonation: ['Unauthorized use of identity'],
      'Personal information': ['PII'],
      Phishing: ['Promoting phishing'],
      Piracy: ['Copyright infringement'],
      'Pre-release play': ['Unauthorized content distribution & methods'],
      'Sensitive content': [
        'Weapons/Safety',
        'Vulgar',
        'Violent extremist content',
        'Self-harm',
        'Violence/Gore',
        'Drugs & alcohol abuse',
        'Controversial'
      ],
      Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
      'Unclear self-identification': ['Self-identification'],
      Terrorism: ['Terrorism'],
      CSEAI: ['CSEAI'],
      'Non-violating': ['Non-violating'],
      Defer: ['Defer']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  },
  {
    allowedAdmins: AllowedAdmins,
    allowedModerators: AllowedModerators,
    caseAssignedLifetimeInSeconds: 900,
    caseOpenLifetimeInSeconds: 14400,
    caseOpenLifetimeWarningFactor: 0.9,
    contentType: ContentType.audio,
    uxPreferences: {
      disableFiltersOnSelect: false,
      showCardTitleGradient: false,
      showReportContext: false,
      showCardZoomOption: true,
      decide: {
        showTimer: true,
        labelsPrompt: [
          {
            CSEAI:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          },
          {
            Terrorism:
              'Images that have been tagged with Child Sexual Exploitative & Abusive Imagery (CSEAI) or Terrorism will be escalated to Online Safety for review.'
          }
        ],
        labelsTop: ['Non-violating', 'Defer'],
        maxAllowedLabels: 0
      },
      feedback: {
        isDefaultCollapsed: false
      },
      subjectImage: {
        blurStrengthPixels: 0,
        isDefaultBlur: false,
        isDefaultFlipped: false,
        isDefaultGrayscale: false,
        isDefaultMirrored: false
      },
      subjectJson: {
        customCss: false
      }
    },
    id: '14',
    moderatorFeedbackCommentOptional: false,
    revision: 1,
    showCaseContext: false,
    notAssignable: false,
    subjectType: 'Audio',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    displayName: '',
    caseOpenLifetimeMaxInSeconds: 28800,
    defaultCaseComparerAlgorithm: 'SourceWeight',
    defaultMaxAssignedCaseCount: 12,
    categorizedTraits: {
      '(non-IRL) CSEAI': ['Digitally-created CSEAI', 'Doctored imagery'],
      Abuse: ['Domestic abuse', 'Animal cruelty'],
      Cheating: ['Offering/Providing/Promoting mods'],
      'Commerce & advertising': ['Advertising'],
      Harassment: [
        'Trolling',
        'Threats',
        'Targeted harassment',
        'Sexual harassment',
        'Retaliation',
        'IRL or non-digital harassment',
        'Hate speech'
      ],
      Impersonation: ['Unauthorized use of identity'],
      'Personal information': ['PII'],
      Phishing: ['Promoting phishing'],
      Piracy: ['Copyright infringement'],
      'Pre-release play': ['Unauthorized content distribution & methods'],
      'Sensitive content': [
        'Weapons/Safety',
        'Vulgar',
        'Violent extremist content',
        'Self-harm',
        'Violence/Gore',
        'Drugs & alcohol abuse',
        'Controversial'
      ],
      Sexual: ['Adult/Sexual', 'Racy/Suggestive', 'Revenge porn', 'Nudity', 'Non-CSEAI child nudity'],
      'Unclear self-identification': ['Self-identification'],
      Terrorism: ['Terrorism'],
      CSEAI: ['CSEAI'],
      'Non-violating': ['Non-violating'],
      Defer: ['Defer']
    },
    sourceTypeWeightMappings: {
      Moderator: 10
    }
  }
];
